export default "__VITE_ASSET__Cmiv769L__"